export class ActivityErrors {
    public static readonly SHORT_DURATION = "A duração deve ser maior que 0";
    public static readonly WRONG_NAME = "O nome da atividade deve ter entre 3 e 100 caracteres";
    public static readonly WRONG_PHASE = "O nome da fase deve ter entre 3 e 100 caracteres";
    public static readonly WRONG_PERCENTAGE = "A porcentagem de recursos a serem utilizados deve estar entre 1 e 100";
}